var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":3},React.createElement("g",{"id":"Supporter-card","transform":"translate(-29.000000, -253.000000)","stroke":"#C4C4C4"},React.createElement("g",{"id":"Page-1","transform":"translate(30.000000, 254.000000)"},[React.createElement("path",{"d":"M6.86855,9.93272222 L4.57043889,12.2308333 C3.72399444,13.0772778 2.35249444,13.0772778 1.50605,12.2308333 L0.995438889,11.7202222 C0.149716667,10.8745 0.149716667,9.50227778 0.995438889,8.65655556 L4.31477222,5.33722222 C5.16121667,4.49077778 6.53343889,4.49077778 7.37916111,5.33722222 L7.88977222,5.84783333","id":"Stroke-1","key":0}),React.createElement("path",{"d":"M6.35793889,3.29376667 L8.65605,0.995655556 C9.50249444,0.149211111 10.8739944,0.149211111 11.7204389,0.995655556 L12.23105,1.50626667 C13.0767722,2.35271111 13.0767722,3.72493333 12.23105,4.57065556 L8.91171667,7.88998889 C8.06527222,8.73643333 6.69305,8.73643333 5.84732778,7.88998889","id":"Stroke-3","key":1})])))]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"15px","height":"15px","viewBox":"0 0 15 15","version":"1.1"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js?name=Icon!./client/assets/icons/chain.svg
// module id = 1250
// module chunks = 0